/**
 * DOUGHNUT_CHART_PDF_CONFIG: a JSON object representing a schema used to drive doughnut charts for HighCharts; used for pdf specific rendering.
 */
export const DOUGHNUT_CHART_PDF_CONFIG = {
	chart: {
		height: 75,
		width: 75,
		spacing: 0,
		marginTop: 5,
		style: {
			fontFamily: 'FortBook, Arial, sans-serif',
			color: null
		},
		type: 'pie'
	},
	plotOptions: {
		pie: {
			dataLabels: {
				enabled: false
			},
			innerSize: '55%',
			startAngle: 0,
			endAngle: 360,
			center: ['50%', '50%']
		}
	},
	responsive: null,
	title: {
		text: null
	},
	tooltip: {
		backgroundColor: '#f9f9f9',
		borderColor: '#a5a5a5',
		borderRadius: 0,
		shadow: false,
		useHTML: true,
		enabled: false,
		style: {
			fontFamily: 'FortBook, Arial, sans-serif'
		}
	}
};
